import { buildStyles, CircularProgressbarWithChildren } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import { useAppSelector } from '../../../app/hooks';
import { AttributeValue } from '../../../Types/Attribute';

interface OeePrimaryDialProps {
    OeeGuid: string;
    timeSpan: number;
}

export default function OeePrimaryDial(props: OeePrimaryDialProps) {
    const attributes = useAppSelector((state) => state.attributesSlice.attributes);

    let oeeValue = 0;
    let averageOee = 0;
    let eightHours = 0;
    let twentyFourHours = 0;
    let sevenDays = 0;
    if (props.OeeGuid !== undefined) {


        var values = attributes.find(attribute => attribute.Guid === props.OeeGuid)?.Values.filter(value => {
            const valueDate = new Date(value.Utc);
            const currentDate = new Date();
            return (currentDate.getTime() - valueDate.getTime()) <= props.timeSpan * 60 * 60 * 1000;
        });
        oeeValue = values && typeof values[values.length - 1]?.Value == 'number' ?
            Number(values[values.length - 1].Value) :
            0;
        averageOee = values ? values.reduce((acc, val) => acc + Number(val.Value), 0) / values.length : 0;

        const attribute = attributes.find(attribute => attribute.Guid === props.OeeGuid);
        if (attribute) {
            const currentDate = new Date();

            const filterValuesByTimespan = (hours: number) =>
                attribute.Values.filter(value => {
                    const valueDate = new Date(value.Utc);
                    return (currentDate.getTime() - valueDate.getTime()) <= hours * 60 * 60 * 1000;
                });

            const values8h = filterValuesByTimespan(8);
            const values24h = filterValuesByTimespan(24);
            const values7days = filterValuesByTimespan(168);

            oeeValue = attribute.Values.length > 0 && typeof attribute.Values[attribute.Values.length - 1]?.Value == 'number'
                ? Number(attribute.Values[attribute.Values.length - 1].Value)
                : 0;

            const calculateAverage = (values: AttributeValue[]) =>
                values.length > 0 ? values.reduce((acc, val) => acc + Number(val.Value), 0) / values.length : 0;

            const averageOee = calculateAverage(attribute.Values);
            eightHours = calculateAverage(values8h);
            twentyFourHours = calculateAverage(values24h);
            sevenDays = calculateAverage(values7days);
        }
    }


    const pathColor = oeeValue > 80 ? "#00B464" : "#FCC449";

    return (
        <div className='flex'>
            <div className='flex justify-center items-center relative text-text-light dark:text-text-dark '>

                <div style={{ width: '10.5rem', height: '10.5rem' }} className=''>
                    <CircularProgressbarWithChildren value={oeeValue}
                        backgroundPadding={0}
                        background
                        strokeWidth={15}
                        styles={buildStyles({
                            pathColor: pathColor,
                            backgroundColor: "#494949",
                            trailColor: "#494949",
                            strokeLinecap: "butt"
                        })} >
                    </CircularProgressbarWithChildren>
                    <div className='text-center pt-2 text-s text-text-light dark:text-text-dark text-base'>LATEST VALUE</div>
                </div>
                <div className="absolute text-4xl font-bold text-text-dark">
                    {typeof oeeValue === 'number' ? `${Math.round(oeeValue)}%` : "-"}
                </div>
            </div>
            <div className="text-right  text-text-light dark:text-text-dark flex-auto ">
                <div className="pt-2 text-sm font-semibold">
                    {`Average ${props.timeSpan > 24 ? props.timeSpan / 24 + "D" : props.timeSpan + "H"} OEE`}
                    <div className="text-base font-bold">
                        {Math.round(eightHours)}%
                    </div>
                </div>
                <div className="pt-2 text-sm font-semibold">
                    Average 24h OEE
                    <div className="text-base font-bold">
                        {Math.round(twentyFourHours)}%
                    </div>
                </div>
                <div className="pt-2 text-sm font-semibold">
                    Average 7d OEE
                    <div className="text-base font-bold">
                        {Math.round(sevenDays)}%
                    </div>
                </div>
            </div>
        </div >
    )
}